import { render } from "./Botbar.vue?vue&type=template&id=4ddaf3ae&scoped=true"
import script from "./Botbar.vue?vue&type=script&lang=js"
export * from "./Botbar.vue?vue&type=script&lang=js"

import "./Botbar.vue?vue&type=style&index=0&id=4ddaf3ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ddaf3ae"]])

export default __exports__